module.exports = __webpack_public_path__ + "img/vignettes-asso_0004_zazakely.d15122ce.jpg";